export default "__VITE_ASSET__gHmFQC5u__"